import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { jumpToSetupSection } from "../../utility/setupJump";
import { isUpNextOnCurrentPage } from "../../utility/tournamentNav";

const actionLabel = (nextStep) =>
  nextStep?.inProgressLabel || nextStep?.title || "";

const UpNextCard = ({
  nextStep,
  variant = "sidebar",
  compact = false,
  onDismiss,
  onNavigate,
}) => {
  const location = useLocation();

  if (!nextStep) return null;

  const [path, hash] = String(nextStep.link || "").split("#");
  const label = actionLabel(nextStep);
  const onThisPage = isUpNextOnCurrentPage(location.pathname, nextStep.link);

  const handleClick = (event) => {
    onNavigate?.();
    if (!hash) return;
    if (location.pathname !== path) return;
    event.preventDefault();
    jumpToSetupSection(hash);
    window.history.replaceState(null, "", `${path}#${hash}`);
  };

  if (compact) {
    if (onThisPage) {
      return (
        <span
          className="flex items-center justify-center w-10 h-10 mx-auto rounded-lg bg-brand-gold/20 text-brand-charcoal"
          title={`Up next: ${label}`}
          aria-label={`Up next: ${label}`}
        >
          <FaArrowRight className="w-3.5 h-3.5" />
        </span>
      );
    }
    return (
      <Link
        to={nextStep.link}
        onClick={handleClick}
        className="flex items-center justify-center w-10 h-10 mx-auto rounded-lg bg-brand-gold text-brand-charcoal hover:bg-brand-gold/90"
        title={`Up next: ${label}`}
        aria-label={`Up next: ${label}. ${nextStep.action}`}
      >
        <FaArrowRight className="w-3.5 h-3.5" />
      </Link>
    );
  }

  const showDismiss = variant === "mobile" && typeof onDismiss === "function";

  return (
    <div className="card-board border-l-4 border-l-brand-gold-ink p-3">
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs font-display font-bold tracking-wider uppercase text-brand-muted">
          Up next
        </p>
        {showDismiss ? (
          <button
            type="button"
            onClick={onDismiss}
            className="text-xs font-medium text-brand-muted hover:text-brand-charcoal"
          >
            Dismiss
          </button>
        ) : null}
      </div>
      <p className="mt-1 text-sm font-display font-bold text-brand-charcoal">
        {label}
      </p>
      {onThisPage ? null : (
        <div className="mt-2">
          <Link
            to={nextStep.link}
            onClick={handleClick}
            className="btn-brand text-sm whitespace-nowrap"
          >
            {nextStep.action}
            <FaArrowRight className="ml-2 h-3 w-3" />
          </Link>
        </div>
      )}
    </div>
  );
};

export default UpNextCard;
